import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LorenBaseMapComponent } from "./components/loren-base-map/loren-base-map.component";
import { LeafletModule } from "@bluehalo/ngx-leaflet";

@NgModule({
  declarations: [LorenBaseMapComponent],
  exports: [LorenBaseMapComponent],
  imports: [CommonModule, LeafletModule],
})
export class LorenBaseMapModule {}
